import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[fieldTrim]',
  standalone: false,
})
export class FieldTrimDirective {
  // Удаляет первый пробел в полях для который применена директива.

  constructor() {}

  @HostListener('input', ['$event', '$event.target.value'])
  onInput(event: string, value: string): void {
    if (event['target']) {
      event['target'].value = value.replace(/^\s/, '');
    }
  }

  @HostListener('paste', ['$event', '$event.target.value'])
  onPaste(event: string, value: string): void {
    if (event['target']) {
      event['target'].value = value.replace(/^\s/, '');
    }
  }
}
